const regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;
const regexZipCode = /^[0-9]{5}(?:-[0-9]{4})?$/;

export { regexEmail, regexZipCode };
